import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import _Button from "../../../../components/generic/_Button";
import { Table } from "../../../../components/ui/Table";
import { FormatInt } from "../../../../utils/FormatData";
import { useRCSHealthDetail } from "../../hooks/useRCSHealthDetail";
const columns = [
  {
    Header: "Partner",
    accessor: "vc_partner",
  },
  {
    Header: "Enviados",
    accessor: "i_sent",
    Cell: (rowData) => {
      let value = rowData.row.original.i_sent;

      return FormatInt(value);
    },
  },
  {
    Header: "Válidos",
    accessor: "i_valids",
    Cell: (rowData) => {
      let value = rowData.row.original.i_valids;

      return FormatInt(value);
    },
  },
  {
    Header: "No Válidos",
    accessor: "i_novalids",
    Cell: (rowData) => {
      let value = rowData.row.original.i_novalids;

      return FormatInt(value);
    },
  },
  {
    Header: "Respuestas",
    accessor: "i_responses",
    Cell: (rowData) => {
      let value = rowData.row.original.i_responses;

      return FormatInt(value);
    },
  },
  {
    Header: "Por Procesar",
    accessor: "i_pending",
    Cell: (rowData) => {
      let value = rowData.row.original.i_pending;

      return FormatInt(value);
    },
  },
  {
    Header: "Errores",
    accessor: "i_errors",
    Cell: (rowData) => {
      let value = rowData.row.original.i_errors;

      return FormatInt(value);
    },
  },
];
const _ModalRCSHealthApi = (props) => {
  const { visible, title, onClose } = props;

  const { data, isPending: loading, isFetching } = useRCSHealthDetail({
    visible,});

  const _onClose = () => {
    if (onClose) onClose();
  };
  return (
    <Modal show={visible} onHide={_onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="text-xl font-semibold text-gray-600">{title}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          columns={columns}
          data={data}
          loading={loading || isFetching}
          config={{
            search: true,
            pageSize: 10,
            perPage: 10,
            pagination: true,
            rowInfo: false,
            navButtons: false,
            rowsPerPageSelection: false,
            footer: true,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <_Button
          title="Cerrar"
          style="primary"
          onClick={_onClose}
          loading={loading}
          disabled={loading}
        />
      </Modal.Footer>
    </Modal>
  );
};

_ModalRCSHealthApi.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  onClose: PropTypes.func,
};

export default _ModalRCSHealthApi;
